/* global jQuery COMPONENTS */

COMPONENTS.ComponentHotspot = (function ($) {
  function ComponentHotspot () {
    this.$component = $('[data-ecs-component="component-hotspot"]')
    this.$slider = this.$component.find('[data-ecs-components-control="hotspot-slider"]')
    this.$cards = this.$component.find('[data-ecs-components-control="hotspot-cards"]')
    this.$hotspotCards = this.$component.find('button[data-ecs-hotspot-linkcard]')
    this.$hotspotButtons = this.$component.find('button[data-ecs-hotspot-linkbutton]')
  }

  ComponentHotspot.prototype.init = function () {
    const component = this
    const utility = new COMPONENTS.Utility()

    if (component.$slider.length >= 1) {
      // hotspot slider on page, init
      const sliderVars = utility.getSliderVars(1, null, true, false, false, false)
      $slider = component.$slider.slick(sliderVars)
      utility.bindSliderAriaSelected($slider)

      $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        component.$hotspotButtons.removeClass('ecs_active')
        component.$component.find('[data-ecs-hotspot-linkbutton="' + nextSlide + '"]').addClass('ecs_active')
      })

      component.$hotspotButtons.click(function() {
        $slider.slick('slickGoTo', $(this).attr('data-ecs-hotspot-linkbutton'))
      })
    }

    // hotspot cards on page
    if (component.$cards.length >= 1) {
      $cards = component.$cards
      $hotspotCards = component.$hotspotCards
      $buttons = component.$hotspotButtons

      component.$hotspotButtons.click(function() {
        $buttons.removeClass('ecs_active')
        $(this).addClass('ecs_active')

        $cards.find('[data-ecs-hotspot-linkcard').removeClass('ecs_active')
        $cards.find('[data-ecs-hotspot-linkcard="' + $(this).attr('data-ecs-hotspot-linkbutton') + '"]').addClass('ecs_active')
      })

      $hotspotCards.click(function() {
        $hotspotCards.removeClass('ecs_active')
        $(this).addClass('ecs_active')

        $buttons.removeClass('ecs_active')
        $('.ecs_hotspots').find('[data-ecs-hotspot-linkbutton="' + $(this).attr('data-ecs-hotspot-linkcard') + '"]').addClass('ecs_active')
      })
    }
  }

  return ComponentHotspot
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.ComponentHotspot = new COMPONENTS.ComponentHotspot()
  COMPONENTS.ComponentHotspot.init()
})
